// extracted by mini-css-extract-plugin
module.exports = {"options":"Options_options__251EK","button":"Options_button__3Xruo","favorite":"Options_favorite__1lX6l"};